import { defineMailTemplate } from '@adornis/mails/db/mail-template-definition.js';
import {
  getMentorAndMenteeMailVariableData,
  getMentorAndMenteeMailVariables,
  MailTemplateType,
} from '../entities/mail-templates.js';

export function registerFreeFormMentor() {
  return defineMailTemplate(MailTemplateType.FREE_FORM_MENTOR, {
    getMailData: getMentorAndMenteeMailVariableData,
    defaultTemplate: {
      subject: ``,
      content: ``,
      footer: '',
    },
    variables: getMentorAndMenteeMailVariables().filter(varName => varName.startsWith('mentor.')),
    attachments: [],
    displayName: 'Freie Mail: Mentor',
    editorHint: () => 'Diese Mail kann frei verwendet werden',
  });
}
